"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var FormControl_1 = __importDefault(require("../../../FormControl"));
var Input_1 = __importDefault(require("../../../Input"));
var Select_1 = __importDefault(require("../../../Select"));
var Tabs_1 = require("../../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../../TextArea"));
exports.errorKeys = [
    'counted_towards',
    'counted_towards_other',
    'num_walls',
    'financial_management',
    'main_walls',
    'insulation',
    'wall_thickness',
    'roof_type',
    'roof_access',
    'roof_access_other',
    'roof_insulation',
    'roof_insulation_other',
    'floors',
    'floors_other',
    'floors_insulation',
];
var HomeVisitForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c;
    var _d = context_1.useSemantics(), trans = _d.trans, options = _d.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var _f = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.home_visit) || {}), formErrors = _f[0], setFormErrors = _f[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.home_visit) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.home_visit]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.home-visit'), subHeading: trans('project:slhh::headings.details') },
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.financial_management, label: trans('project:slhh::labels.financial-management'), help: trans('project:slhh::help.financial-management') },
            react_1.default.createElement(Select_1.default, { options: {
                    comfortable: 'Living Comfortably',
                    alright: 'Doing Alright',
                    getting_by: 'Just about getting by',
                    quite_difficult: 'Finding it quite difficult',
                    very_difficult: 'finding it very difficult',
                }, width: "xs", name: "project.home_visit.financial_management" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.num_walls, label: trans('project:slhh::labels.num-walls') },
            react_1.default.createElement(Input_1.default, { fast: true, width: "xs", name: "project.home_visit.num_walls", maxLength: 200 })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.main_walls, label: trans('project:slhh::labels.main-walls') },
            react_1.default.createElement(Select_1.default, { options: {
                    solid_brick: 'Solid Brick',
                    cavity: 'Cavity',
                    timber: 'Timber frame',
                    system: 'System built',
                }, width: "xs", name: "project.home_visit.main_walls" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.insulation, label: trans('project:slhh::labels.insulation') },
            react_1.default.createElement(Select_1.default, { options: {
                    external: 'External',
                    internal: 'Internal',
                    as_built: 'As built',
                    unknown: 'Unknown',
                }, width: "xs", name: "project.home_visit.insulation" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.wall_thickness, label: trans('project:slhh::labels.wall-thickness'), help: trans('project:slhh::help.wall-thickness') },
            react_1.default.createElement(Input_1.default, { fast: true, width: "xs", name: "project.home_visit.wall_thickness", maxLength: 200 })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.roof_type, label: trans('project:slhh::labels.roof-type') },
            react_1.default.createElement(Select_1.default, { options: {
                    pitched: 'Pitched',
                    flat: 'Flat',
                    above: 'Another property above',
                    other: 'Other',
                }, width: "xs", name: "project.home_visit.roof_type" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.roof_type, label: trans('project:slhh::labels.roof-access'), help: trans('project:slhh::help.roof-access') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: options.booleanOther(), name: "project.home_visit.roof_access" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.roof_insulation, label: trans('project:slhh::labels.roof-insulation'), help: trans('project:slhh::help.roof-insulation'), showOther: values.project.home_visit.roof_insulation === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(FormControl_1.default, { errors: formErrors.roof_insulation_other, label: trans('project:slhh::labels.applied-for-other') },
                react_1.default.createElement(TextArea_1.default, { fast: true, name: "project.home_visit.roof_insulation_other", maxLength: 5000 })) },
            react_1.default.createElement(Select_1.default, { options: {
                    below: 'Below 100mm (below joists)',
                    over: 'Over 100mm (above joists)',
                    other: 'Other',
                }, width: "xs", name: "project.home_visit.roof_insulation" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.floors, label: trans('project:slhh::labels.floors'), showOther: values.project.home_visit.floors === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(FormControl_1.default, { errors: formErrors.floors_other, label: trans('project:slhh::labels.applied-for-other') },
                react_1.default.createElement(TextArea_1.default, { fast: true, name: "project.home_visit.floors_other", maxLength: 5000 })) },
            react_1.default.createElement(Select_1.default, { options: {
                    suspended: 'Suspended Timber',
                    solid: 'Solid',
                    unknown: 'Unknown',
                    dwelling_below: 'Another dwelling bellow',
                    other: 'Other',
                }, width: "xs", name: "project.home_visit.floors" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.floors_insulation, label: trans('project:slhh::labels.floors-insulation'), help: trans('project:slhh::help.floors-insulation'), flush: true },
            react_1.default.createElement(Select_1.default, { options: {
                    as_built: 'As Built',
                    retro: 'Retro fitted',
                    unknown: 'Unknown',
                    none: 'None',
                }, width: "xs", name: "project.home_visit.floors_insulation" }))));
};
exports.default = HomeVisitForm;
//# sourceMappingURL=HomeVisitForm.js.map